import { Link, useNavigate } from 'react-router-dom'
import { LAB_META, getLabMap } from '../game/maps/labs'
import { measureLaneMap, SMALL_TOWER_RANGE } from '../game/maps/laneMetrics'
import { sharedGroundCells } from '../game/maps/routeTopology'
import { useGameStore } from '../store/gameStore'
import './DevLabsPage.css'

/**
 * DEV-only map laboratory launcher.
 * Not linked from player HOME.
 */
export function DevLabsPage() {
  const startPlaytest = useGameStore((s) => s.startPlaytest)
  const navigate = useNavigate()

  return (
    <main className="dev-labs" data-testid="dev-labs">
      <header className="dev-labs__header">
        <p className="dev-labs__eyebrow">DEV ONLY</p>
        <h1 className="dev-labs__title">Map Design Laboratory</h1>
        <p className="dev-labs__sub">
          Experimental route topologies. Not campaign content.
        </p>
        <div className="dev-labs__nav">
          <Link to="/">Home</Link>
          <Link to="/map-editor">Map editor</Link>
        </div>
      </header>
      <ul className="dev-labs__list">
        {LAB_META.map((lab) => {
          const map = getLabMap(lab.id)!
          const metrics = measureLaneMap(map, SMALL_TOWER_RANGE)
          const shared = sharedGroundCells(map).length
          return (
            <li key={lab.id} className="dev-labs__card" data-testid={`lab-${lab.id}`}>
              <div className="dev-labs__card-head">
                <h2>{lab.name}</h2>
                <span className="dev-labs__topo">{lab.topology}</span>
              </div>
              <p className="dev-labs__purpose">{lab.purpose}</p>
              <dl className="dev-labs__stats">
                <div>
                  <dt>Size</dt>
                  <dd>
                    {map.width}×{map.height}
                  </dd>
                </div>
                <div>
                  <dt>Ground</dt>
                  <dd>{lab.groundRoutes.join(', ')}</dd>
                </div>
                <div>
                  <dt>Air</dt>
                  <dd>{lab.airRoutes.length ? lab.airRoutes.join(', ') : '—'}</dd>
                </div>
                <div>
                  <dt>Shared cells</dt>
                  <dd>{shared}</dd>
                </div>
                <div>
                  <dt>2×2 anchors</dt>
                  <dd>{metrics.coverage.anchors}</dd>
                </div>
                <div>
                  <dt>Multi-route</dt>
                  <dd>{metrics.coverage.anchorsMultiLane}</dd>
                </div>
              </dl>
              <button
                type="button"
                className="dev-labs__play"
                data-testid={`lab-play-${lab.id}`}
                onClick={() => {
                  startPlaytest(map)
                  navigate('/')
                }}
              >
                PLAYTEST
              </button>
            </li>
          )
        })}
      </ul>
    </main>
  )
}
